import * as React from 'react';
import * as autoBind from 'react-autobind';
import TabModel from '../../types/TabModel';

const getInitialState = (props: TabsProps): TabsState => {
   const index = props.tabs.findIndex(tab => tab.selected);
   return {activeIndex: index !== -1 ? index : 0};
};

export default class Tabs extends React.Component<TabsProps, TabsState> {
   readonly state: TabsState = getInitialState(this.props);
   tabContainer: HTMLElement;

   constructor(props: TabsProps) {
      super(props);
      autoBind(this);
   }

   getTab(tab: TabModel, index: number) {
      const {isAnchor} = this.props;
      const onClick = (e: any): void => {
         this.setState({activeIndex: index});

         if (tab.onClick) {
            e.preventDefault();
            tab.onClick();
         }
      };

      let className = index === this.state.activeIndex ? 'tab selected' : 'tab';
      className = !isAnchor ? className + ' tab-button' : className;

      return isAnchor ?
         <a href={tab.href} className={className} key={index} onClick={onClick}><span>{tab.text}</span></a>
         : <button className={className} key={index} onClick={onClick}><span className="tab-button-span" tabIndex={-1}>{tab.text}</span></button>;
   }

   setRef(tabContainer: HTMLElement) {
      this.tabContainer = tabContainer;
   }

   render() {
      const {tabs} = this.props;

      return (
         <div className="tabs" ref={this.setRef}>
            {tabs && tabs.map((tab, index) => this.getTab(tab, index))}
         </div>
      );
   }
}

export interface TabsState {
   activeIndex: number;
}

export interface TabsProps {
   tabs: TabModel[];
   isAnchor: boolean;
}
